import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    profile: (state) => state.profile,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarTheme: (state) => state.leftSidebarTheme,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
  }),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'getProfile',
  'updateProfile',
  'updatePhoto',
  'updateUsername',
  'updatePassword',
  'forgotPassword',
  'validateForgotToken',
  'changePassword',
])

export const layoutMethods = mapActions('layout', [
  'changeLayoutType',
  'changeLeftSidebarTheme',
  'changeLeftSidebarType',
  'changeLayoutWidth',
])

export const rolesActions = mapActions('roles', [
  'getRoles',
  'addRole',
  'updateRole',
  'deleteRole'
])

export const usersActions = mapActions('users', [
  'getUsers',
  'getUserById',
  'registerUser',
  'updateUser',
  'updateUserStatus',
  'updateUserPhoto'
])

export const companiesActions = mapActions('companies', [
  'getCompanies',
])

export const menusActions = mapActions('menus', [
  'getMenus',
  'getMenusByRole',
  'saveRolePrivilege'
])

export const fleetsActions = mapActions('fleets', [
  'getFleets',
  'getFleetActivities',
  'getFleetById',
  'addFleet',
  'getFleetTypes',
  'addFleetType',
  'updateFleetType',
  'updateFleet',
  'deleteFleet',
  'deleteFleetType'
])

export const filesActions = mapActions('files', [
  'upload',
])

export const logsActions = mapActions('logs', [
  'getLogs',
])

export const structuresActions = mapActions('structures', [
  'getStructures',
  'saveStructures'
])

export const portsActions = mapActions('ports', [
  'getPorts',
  'getPortById',
  'savePort',
  'updatePort',
  'deletePort',
  'exportPort'
])

export const projectsActions = mapActions('projects', [
  'getProjects',
  'getProjectById',
  'addProject',
  'addProjectDetail',
  'updateProjectDetail',
  'deleteProject',
  'exportProjects',
])

export const reasonsActions = mapActions('reasons', [
  'getReasons',
  'getReasonById',
  'addReason',
  'updateReason',
  'deleteReason',
  'exportReasons'
])

export const modulesActions = mapActions('modules', [
  'getModules',
  'getModuleCategories',
  'addModule',
  'saveModuleCategories',
  'updateModule',
  'deleteModule',
])

export const certificatesActions = mapActions('certificates', [
  'getCertificates',
  'getCertificateVehicles',
  'getCertificateVehicleLogs',
  'getCertificateById',
  'getCertificateVehicleById',
  'getCertificateCategories',
  'addCertificate',
  'addCertificateVehicle',
  'updateCertificateCategory',
  'addCertificateCategory',
  'processRenewalCertificateVehicle',
  'finishRenewalCertificateVehicle',
  'endorsementCertificateVehicle',
  'updateCertificate',
  'updateCertificateVehicle',
  'deleteCertificate',
  'deleteCertificateVehicle',
  'exportCertificates',
  'exportCertificateVehicles',
  'getEndorsementDates'
])

export const notificationsActions = mapActions('notifications', [
  'getNotifications',
  'readNotification',
])

export const powerActions = mapActions('power', [
  'getPowerTypes',
  'getPowerSeries',
  'getPowerTypeById',
  'getPowerSeriesById',
  'savePowerType',
  'savePowerSeries',
  'deletePowerTypeById',
  'deletePowerSeriesById',
  'updatePowerType',
  'updatePowerSeries',
])

export const robActions = mapActions('rob', [
  'getRobTypes',
  'getRobSeries',
  'getRobTypeById',
  'getRobSeriesById',
  'saveRobType',
  'saveRobSeries',
  'deleteRobTypeById',
  'deleteRobSeriesById',
  'updateRobType',
  'updateRobSeries',
])

export const vdrActions = mapActions('vdr', [
  'getVDR',
  'getVDRbyVehicle',
  'getVDRbyVehicleDetail',
  'addVDR',
  'deleteVDRbyVehicle',
  'updateStatusVDRbyVehicle',
  'updateVDRbyVehicle'
])